export default __webpack_public_path__ + "static/media/element_13.2641add0.webp";